import React from 'react';
import { useTranslation } from 'react-i18next';
import './EnvironmentBanner.css';

const EnvironmentBanner: React.FC = () => {
  const { t } = useTranslation();
  const environment = process.env.REACT_APP_ENVIRONMENT;

  // Don't show banner in production
  if (environment === 'production') {
    return null;
  }

  // Map environment to display text
  const getEnvironmentConfig = () => {
    switch (environment) {
      case 'test':
        return {
          label: t('environmentBanner.test'),
          className: 'environment-banner-test'
        };
      case 'staging':
        return {
          label: t('environmentBanner.staging'),
          className: 'environment-banner-staging'
        };
      default:
        return null;
    }
  };

  const config = getEnvironmentConfig();

  if (!config) {
    return null;
  }

  return (
    <div className={`environment-banner ${config.className}`}>
      <span className="environment-banner-text">{config.label}</span>
    </div>
  );
};

export default EnvironmentBanner;
